// extracted by mini-css-extract-plugin
export default {"wrapperPromocion":"futureTopupModal_wrapperPromocion__sRqG2","wrapperNow":"futureTopupModal_wrapperNow__PRlXK"};